import React from "react"
import "./SectionHeader.scss"
const SectionHeader = ({heading, className="large"}) => {
  return <h2 className={`section-header ${className}`}>{heading}</h2>
}

export default SectionHeader
